"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Inner = exports.IconMargin = void 0;

var tslib_1 = require("tslib");

var ui_icon_1 = require("@hopin-team/ui-icon");

var react_1 = tslib_1.__importDefault(require("react"));

var decorator_1 = require("../styled/decorator");

var root_1 = require("../styled/root");

var IconMargin;

(function (IconMargin) {
  IconMargin[IconMargin["tiny"] = 1] = "tiny";
  IconMargin[IconMargin["small"] = 2] = "small";
  IconMargin[IconMargin["medium"] = 2] = "medium";
  IconMargin[IconMargin["large"] = 2] = "large";
})(IconMargin = exports.IconMargin || (exports.IconMargin = {}));

var getColor = function getColor(_a) {
  var isInverse = _a.isInverse,
      isOutlined = _a.isOutlined,
      disabled = _a.disabled;

  switch (true) {
    case disabled:
      {
        return 'grey-500';
      }

    case isInverse:
    case !isOutlined:
      {
        return 'grey-white';
      }

    default:
      {
        return 'grey-800';
      }
  }
};

var Inner = function Inner(_a) {
  var children = _a.children,
      disabled = _a.disabled,
      isInverse = _a.isInverse,
      isOutlined = _a.isOutlined,
      leadingIcon = _a.leadingIcon,
      size = _a.size,
      trailingIcon = _a.trailingIcon;
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(decorator_1.Decorator, null, leadingIcon && react_1.default.createElement(ui_icon_1.Icon, {
    name: leadingIcon,
    title: leadingIcon,
    "aria-hidden": true,
    ml: IconMargin[size],
    mr: root_1.SizePadding[size],
    color: getColor({
      isOutlined: isOutlined,
      isInverse: isInverse,
      disabled: disabled
    })
  })), children, react_1.default.createElement(decorator_1.Decorator, null, trailingIcon && react_1.default.createElement(ui_icon_1.Icon, {
    name: trailingIcon,
    title: trailingIcon,
    "aria-hidden": true,
    mr: IconMargin[size],
    ml: root_1.SizePadding[size],
    color: getColor({
      isOutlined: isOutlined,
      isInverse: isInverse,
      disabled: disabled
    })
  })));
};

exports.Inner = Inner;